module.exports = __webpack_public_path__ + "static/img/max_pictgrid31_980x870.a385f12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid31_980x870.jpg
// module id = dJwr
// module chunks = 0